export const linkTypeList = [
  { label: 'Android', value: 1 },
  { label: 'IOS', value: 2 },
  { label: 'Android+IOS', value: 3 },
  { label: '快应用', value: 4 }
]

export const linkTypeMap = {
  1: 'Android',
  2: 'IOS',
  3: 'Android+IOS',
  4: '快应用'
}
